export default __webpack_public_path__ + "static/media/z_wdt_c_2.46e047e4.mp3";